import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import Label from '../../../constants/Label';
import styles from './norecord.module.scss';

const NoRecord = (props) => {
  let status = props.status;
  return status ? <h4 className={styles.textCenter}>{Label.ListError.errorMessage}</h4> : <div className={styles.spinner}></div>;
};

export { NoRecord };
